<script setup lang="ts">
import { AppStandardModal, AppPortableText } from '@libs/ui';

import { PremadeTripType } from '../../models';
import type { PremadeTrip } from '../../models';
import AITripDescription from '../tripOverviewHeader/AITripDescription.vue';

interface PremadeTripDescriptionModalProps {
  premadeTrip: PremadeTrip;
}

const props = defineProps<PremadeTripDescriptionModalProps>();

interface PremadeTripDescriptionModalEmits {
  (eventName: 'close'): void;
}

const emit = defineEmits<PremadeTripDescriptionModalEmits>();
</script>

<template>
  <AppStandardModal
    class="modal"
    :close-button-aria-label="$t('a11y.close_panel')"
    @close="emit('close')"
  >
    <template #title>
      <div class="title">
        {{ props.premadeTrip.headline }}
      </div>
    </template>
    <template #body>
      <AppPortableText
        v-if="props.premadeTrip.type === PremadeTripType.PublishedInSanity"
        type="premade-trip-modal"
        :portable-text="props.premadeTrip.description"
      />
      <AITripDescription
        v-if="props.premadeTrip.type === PremadeTripType.AI"
        :description="props.premadeTrip.description"
      />
    </template>
  </AppStandardModal>
</template>
